const list = "_b7nl1sd5ppi";
const button = "_b7nbc891rj";
const bullet = "_b7nbte862q";

export { bullet, button, list };
import "./atom.bullets.style.linaria.module.css";
//# sourceMappingURL=atom.bullets.style.js.map
